export default function loginDataSelector(func) {
  return func((state) => state.loginReducer);
}
